// import React, { useEffect } from "react";
import "../styles/Banner.scss";

// import AOS from 'aos';
// import 'aos/dist/aos.css';

const BannerUpper = () => {
  //     useEffect(() => {
  //         AOS.init({duration: 2000});
  //         AOS.refresh();
  //     }, []);

  return <div className="banner-upper"></div>;
};

export default BannerUpper;
